import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../api/client';
import { applyTheme } from '../utils/theme';

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const fetchSettings = useCallback(async () => {
    try {
      const res = await api.get('/settings');
      setSettings(res.data);
      applyTheme(res.data);
    } catch {
      // defaults applied in CSS
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('checkbuild_token');
    if (token) fetchSettings();
  }, [fetchSettings]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
